import { SelectContext } from '../../../context'

/**
 * @property {boolean} [disabled]
 * disabled: the control is visually and functionally disabled
 *
 * @property {boolean} [blocked]
 * blocked: behaves like disabled (no clicks, no value changes),
 * but keeps the normal visual style (no opacity change) and
 * shows a "not-allowed" cursor. Unlike "readonly", it should not
 * handle clicks or focus changes at all.
 */
function SelectContextProvider({
  EntityIcon,
  activeIndex,
  blocked,
  canSelectAll,
  children,
  closeDropdownOnClear,
  disabled,
  error,
  getFloatingItemProps,
  isOpen,
  multi,
  qaName,
  searchValue,
  showSelected,
  value,
  onChangeSearch,
  onClear,
  onClearSearch,
  onClose,
  onOpen,
  onSelect,
  onSelectAll,
  onToggleOpen,
  onToggleShowSelected,
}) {
  function handleChangeSearch(event) {
    onChangeSearch(event.target.value)
  }

  function handleClear(event) {
    onClear(event)

    if (closeDropdownOnClear) {
      onClose()
    }
  }

  const context = {
    EntityIcon,
    activeIndex,
    blocked,
    canSelectAll,
    disabled,
    error,
    getFloatingItemProps,
    handleChangeSearch,
    handleClear,
    handleClearSearch: onClearSearch,
    handleClose: onClose,
    handleOpen: onOpen,
    handleSelect: onSelect,
    handleSelectAll: onSelectAll,
    handleToggleOpen: onToggleOpen,
    handleToggleShowSelected: onToggleShowSelected,
    isOpen,
    multi,
    qaName,
    searchValue,
    showSelected,
    value,
  }

  return <SelectContext value={context}>{children}</SelectContext>
}

export default SelectContextProvider
